export const GLOBAL_RESET = 'GLOBAL_RESET'
